<template>
    <section v-if="brand" 
            class="product-brand-content">
        <figure>
            <img :src="brand.file.uri" />
            <figcaption v-text="brand.title" />
        </figure>
	</section> 
</template>

<script>
import { filesComputed } from '@/features/files/store'
import { productsComputed } from '@/features/products/store'
export default {
    props: {
        name: {
            type: String,
            required: true,
            default: 'Not Found'
        }
    },
    computed: {
        ...filesComputed,
        ...productsComputed,
        brand(){
            return this.productsBrands
                    .find(temp => temp.title.toUpperCase() == this.name.toUpperCase())
        }
    }
}
</script>